import { ExternalLink, Play } from "lucide-react";
import Reveal from "@/components/escape21/Reveal";

const VIDEOS = [
  {
    title: "rotina produtiva de um jovem empreendedor aos 17 anos",
    views: "21 mil",
    thumbnail: "/lovable-uploads/3cb01bd0-09a1-467d-a5d8-fab84fc917ba.png",
    link: "https://youtu.be/4tORbOriJsg?si=Lp1rYnnyaCcJ4GE0",
  },
  {
    title: "minha nova rotina morando sozinho aos 18 anos",
    views: "8,1 mil",
    thumbnail: "/lovable-uploads/e5be2cde-5802-4337-abcb-020553ea3b7c.png",
    link: "https://youtu.be/FVqP0MdvQZ0?si=brolLNVlQX5DPgzE",
  },
  {
    title: "se 2025 não for diferente, a culpa é sua",
    views: "5,1 mil",
    thumbnail: "/lovable-uploads/c9881328-15f5-4a1a-b9c0-bb22a31baacd.png",
    link: "https://youtu.be/69aANZlXH7U?si=L0faJpu55Dr7ckK7",
  },
];

const YouTube = () => (
  <section className="px-6 py-20 sm:py-28">
    <div className="mx-auto max-w-5xl">
      <Reveal className="text-center">
        <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-white/35">
          youtube
        </span>
        <h2 className="mt-4 text-3xl font-extrabold leading-tight tracking-[-0.03em] sm:text-5xl">
          formato longo pra quem quer <span className="e21-serif text-green-400">profundidade</span>.
        </h2>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-3">
        {VIDEOS.map((v, i) => (
          <Reveal
            key={v.link}
            delay={i * 100}
            className="group overflow-hidden rounded-2xl border border-white/10 bg-white/5 transition-colors hover:bg-white/[0.08]"
          >
            <a href={v.link} target="_blank" rel="noopener noreferrer" className="block">
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={v.thumbnail}
                  alt={v.title}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <Play size={40} className="text-white/80 transition-transform group-hover:scale-110" />
                </div>
                <ExternalLink
                  size={18}
                  className="absolute right-4 top-4 text-white/70 transition-colors group-hover:text-white"
                />
              </div>
              <div className="p-6">
                <h3 className="text-sm font-bold tracking-[-0.02em] text-white">{v.title}</h3>
                <p className="mt-2 text-sm">
                  <span className="font-bold text-white">{v.views}</span>
                  <span className="text-white/50"> visualizações</span>
                </p>
              </div>
            </a>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default YouTube;
